export default __webpack_public_path__ + "static/media/logo_small.6911adc9.png";